import React from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';

import { Button, Popconfirm } from 'antd';

import { dispatch, useGlobalState } from '../../../store/state';
// import { SyncCampiagnData } from '../../../utils/SyncCampiagnData';
import moment from 'moment';
// import { CampaignDelete } from '../../../apis/Brand/Campaigns/CampaignDelete';
import { FiEdit } from 'react-icons/fi';
import { RiDeleteBin5Line } from 'react-icons/ri';
import './CampaignCardComponent.styles.scss';

const CampaignCardComponent = ({ status, timeLeft, createdOn, title, campaignid, socialIcons, taskCount, deleteCampaign, rowData }) => {
  const history = useHistory();
  const params = useParams();
  // const [user] = useGlobalState('user')
  const [company] = useGlobalState('company');
  // const [create_camp_general] = useGlobalState('create_camp_general')
  const [create_camp_draft] = useGlobalState('create_camp_draft');
  const [campDefSet] = useGlobalState('campDefSet');
  const createDynamicDraftPage = ()=>{
    if (Object.keys(create_camp_draft).length === 0) { // loading template if not there
      dispatch({
        type: 'CREATE_CAMP_DATA',
        payload: campDefSet,
      });
    }
    history.push(`/brand/${params.companyId}/campaign/${campaignid}`);
    // if(!forceEdit){
    // }else{
    //     history.push(`/brand/${params.companyId}/campaign/${campaignid}`)
    // }
  };


  return (
    <div className="col-lg-4 col-md-6 p-2">
      <div className="campaign_card h-100">
        <div className="d-flex flex-column justify-content-between h-100">

          <div>
            <div className="campaign_card_top">
              <div className="campaign_card_top--status"
                status={status}>{status}</div>
              <div className="campaign_card_top_stamps">
                {/* <div className="campaign_card_top_stamps--left">Starts {timeLeft}</div> */}
                <div className="campaign_card_top_stamps--left"><div>Campaign Id</div> {campaignid}</div>
                {/* <div className="campaign_card_top_stamps--creation"><div>Created on</div> {moment(createdOn).format('Do MMM YYYY')}</div> */}
              </div>
            </div>
            <h2 className="campaign_card--title mt-3">{title}</h2>
            <h5 className="campaign_card--id">Campaign starts {timeLeft}</h5>
            {/* <h5 className="campaign_card--id"><span>Campaign ID</span>{campaignid}</h5> */}
            <h5 className="campaign_card--id"><span>Created on</span>{moment(createdOn).format('Do MMM YYYY')}</h5>
            {/* <div className="campaign_card_top_stamps--creation"><div>Created on</div> {moment(createdOn).format('Do MMM YYYY')}</div> */}
          </div>

          <div>
            <div className="campaign_card_bottom mt-2">
              <div className="campaign_card_bottom_obj">
                {/* <h6>Platform</h6> */}
                <div className="campaign_card_bottom_obj--social">
                  <i>Platform</i>
                  {socialIcons}
                  {/* <span>
                                        <FaFacebookF/>
                                    </span>
                                    <span>
                                        <FaInstagram/>
                                    </span> */}
                </div>
                <p>{taskCount}</p>
              </div>
              <div className="campaign_card_bottom_actions">
                {status === 'draft' ?
                  (
                    <>
                      <Button className="common_button outlined"
                        onClick={() => deleteCampaign(campaignid)}>
                        <RiDeleteBin5Line className="mr-1"
                          size={13}/>Delete
                      </Button>
                      <Button className="common_button outlined"
                        onClick={createDynamicDraftPage}>
                        <FiEdit className="mr-1"
                          size={13}/> Edit
                      </Button>
                    </>
                  ):
                  null
                }
                {status === 'review' ?
                  (
                    <>
                      <Link to={`/brand/${company.selected.id}/campaign/${campaignid}/details`}>
                        <Button className="common_button outlined">Overview</Button>
                      </Link>
                      <Popconfirm
                        title="Editing the campaign will change the status from review to draft"
                        onConfirm={() => createDynamicDraftPage()}
                        // onCancel={handleCancel}
                      >
                        <Button className="common_button outlined"><FiEdit className="mr-1"
                          size={13}/> Edit</Button>
                      </Popconfirm>
                    </>
                  ):
                  null
                }
                {status === 'pendingpayment' || status === 'paymentpending' ?
                  (
                    <>
                      <Link to={`/brand/${company.selected.id}/credit`}>
                        <Button className="common_button outlined">Make Payment</Button>
                      </Link>
                    </>
                  ):
                  null
                }
                {status === 'published' ?
                  (
                    <>
                      <Link to={`/brand/${company.selected.id}/campaign/${campaignid}/details`}>
                        <Button className="common_button outlined">Overview</Button>
                      </Link>
                    </>
                  ):
                  null
                }
                {status === 'active' || status === 'completed' ?
                  (
                    <>
                      <Link to={`/brand/${company.selected.id}/stats/${campaignid}`}>
                        <Button className="common_button outlined">Overview</Button>
                      </Link>
                    </>
                  ):
                  null
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignCardComponent;
